<div
  class="member-card-with-wallet bg-{{ theme }}"
  *ngIf="memberCard$ | async as memberCard"
  [ngClass]="(memberCard$ | async).ProductCode | background"
>
  <div class="member-card-info" *ngIf="memberDetails$ | async as memberDetails">
    <div class="member-info text-white">
      <h5 class="pt-2 mb-1 fw-bold card-name w-100">{{ memberDetails.FirstName }} {{ memberDetails.Surname }}</h5>
      <div class="d-flex font-size-12">
        <div class="product-code">{{ memberCard.ProductCode }} - {{ memberCard.ExternalRefNumber }}</div>
      </div>
    </div>
    @if (showWalletButton) {
    <div class="action-button-wrapper ms-auto" [ngClass]="memberCard.ProductCode | background">
      <a
        class="btn rounded text-white memcard-wallet-btn"
        [routerLink]="['/rewards/wallet']"
        [ngClass]="{
          'btn-primary': theme !== 'primary',
          'btn-black': theme === 'primary'
        }"
      >
        <span class="fw-bold">{{ 'membercard.wallet.button' | translate }}</span>
      </a>
    </div>

    }
  </div>
  <div class="points-info bg-white rounded mt-4 mb-2">
    <span class="points-value font-size-14 fw-bold">{{ pointsBalance$ | async | number }}</span>
    <label class="fw-normal">{{ 'membercard.points.label' | translate }}</label>
  </div>
</div>
